import React from 'react'
import WorkersByGroupChartCard from 'components/common/WorkersByGroupChartCard'

const WorkersSection = ({ leamData, workdayData, previousDate }) => {
  return (
    <div className='grid grid-cols-1 lg:grid-cols-2 gap-4 mt-4'>
      <WorkersByGroupChartCard
        data={leamData.workersByGroupYesterday}
        totalWorkers={workdayData.totalWorkers}
        title='Workers By Group (Yesterday)'
        cardColor='green'
        currentDate={previousDate}
      />
      <WorkersByGroupChartCard
        data={workdayData.workersByGroup}
        totalWorkers={workdayData.totalWorkers}
        title='Workers By Group (Today)'
        cardColor='green'
        currentDate={workdayData.currentDate}
      />
    </div>
  )
}

export default WorkersSection
